import React, { createRef, useEffect, useState }                                     from "react"
import { useParams }                                                                 from "react-router";
import moment                                                                        from "moment"
import shop                                                                          from "shop/shop"
import { Button, Container, Menu, Icon, Table, Modal, Form, Dropdown, Input, Label } from "semantic-ui-react";
import { Link, NavLink }                                                             from "react-router-dom";
import BudgetManager                                                                 from "../../../../components/Budget/BudgetManager";
import "../../../../components/Budget/ModalForm.css"
import { loadState }                                                                 from "sdk/util/loadState";
import SortimentManager                                                              from "../../../../components/Budget/SortimentManager";
import useQuery                                                                      from "../../../../useQuery";
import config                                                                        from "config"
import CreateCostCentreModal                                                         from "../../../../components/CostCentres/CostCentresEditForm.js"

export default function CustomerDetailPage( { onSelect } ) {
  const params = useParams()
  const query = useQuery()
  const { section = "" } = query
  const [users, setUsers] = useState( false )
  const [customer, setCustomer] = useState( false )
  const [costCentres, setCostCentres] = useState( false )
  const [logins, setLogins] = useState( false )
  const [user, setUser] = useState( false )


  const [showNewAccountModal, setShowNewAccountModal] = useState( false )
  const [showEditAccountModal, setShowEditAccountModal] = useState( false )

  const { customerId } = params
  console.log( { customerId, section } )
  // useEffect( loadState( setCustomer, `/shop/rest/data/customer/${customerId}` ), [customerId] )

  // if handuser load from backend otherwise take current customer
  if (shop.session.handId) {
    useEffect( loadState( setCustomer, `/shop/rest/data/customer/${customerId}` ), [customerId] )
  } else {
    useEffect( () => { setCustomer( shop.session.value ) },[] )
  }
  useEffect( loadState( setUsers, `/shop/rest/users/data?start=0&count=100&filter=${encodeURIComponent( JSON.stringify( { customer_id: customerId } ) )}` ), [customerId, showEditAccountModal, showNewAccountModal] )
  useEffect( loadState( setCostCentres, `/shop/rest/costcentre/data?start=0&count=120&customer=${customerId}` ), [customerId] )
  const loading = !(customer || costCentres || users)

  return <div>
    {showEditAccountModal && <EditCustomerModal
      customerId={customerId}
      customer={customer}
      user={showEditAccountModal}
      onClose={() => {
        setShowEditAccountModal( false )
      }}
      open={showEditAccountModal}>
    </EditCustomerModal>}

    <CreateCustomerModal
      customerId={customerId}
      customer={customer}
      onClose={() => {
        setShowNewAccountModal( false )
      }}
      open={showNewAccountModal}
    />

    {!loading && <div className="">
      <div className={"bg-silver "}>

        <div className="bg-white pv5-ns pv4">
          <Container>
            {/*<div>*/}
            {/*  <div><Link className="pv2 db" to={`/login/accounts/`}><Icon name={"chevron left"}/> {translate( "Kundenübersicht" )}</Link></div>*/}
            {/*</div>*/}
            <div className="flex flex-row items-center justify-between">
              <div className="f2 b lh-title">
                <div>{customer.title}</div>
              </div>
              <div>
                <Button size="tiny" as={Link} to={"/account/"} basic>{translate("Zurück")}</Button>
                {shop.session.handId && <Button size="tiny" as={Link} to={"/login/accounts/"} basic>{translate( "Kunde wechseln" )}</Button> }
                {shop.session.handId && <Button size="tiny" onClick={() => {
                    onSelect( { customer } )
                  }} primary>{translate( "Anmelden" )}</Button> }
              </div>
            </div>
          </Container>
        </div>


        <div className="bg-silver pv5-ns pv4">
          <Container>
            <div className="">
              {/*<Menu vertical basic fluid>*/}
              {/*  <Menu.Item as={Link} active={section === ''} exact to={"./?section="}>Daten</Menu.Item>*/}
              {/*  <Menu.Item as={Link} active={section === "budget"} exact to={"./?section=budget"}>Budget</Menu.Item>*/}
              {/*  <Menu.Item as={Link} active={section === "sortiment"} exact to={"./?section=sortiment"}>Sortiment</Menu.Item>*/}
              {/*  <Menu.Item as={Link} active={section === "konten"} exact to={"./?section=konten"}>Konten</Menu.Item>*/}
              {/*</Menu>*/}

              <div className="">
                <h2 className="b">{translate( "Übersicht" )}</h2>

                <div className="bg-white pa4 shadow-5 flex flex-row justify-between flex-wrap">
                  <div className="pa2 pr2">
                    <div className={"black-70 ttu f6"}>{translate( "Kundenname" )}</div>
                    <div className={"b black-90 f5"}>{customer.title}</div>
                  </div>

                  <div className="pa2 pr2">
                    <div className={"black-70 ttu f6"}>{translate( "Kundennummer" )}</div>
                    <div className={"b black-90 f5"}>{customer.map_id}</div>
                  </div>

                  <div className="pa2 pr2">
                    <div className={"black-70 ttu f6"}>{translate( "Sprache" )}</div>
                    <div className={"b black-90 f5 ttu"}>{customer.lang} {customer.country}</div>
                  </div>

                  {/*<div className="pa2 pr2">*/}
                  {/*  <div className={"black-70 ttu f6"}>{translate( "Preisliste" )}</div>*/}
                  {/*  <div className={"b black-90 f5"}>{customer.pricelist}</div>*/}
                  {/*</div>*/}

                  <div className="pa2 pr2">
                    <div className={"black-70 ttu f6"}>{translate( "Ort" )}</div>
                    <div className={"b black-90 f5"}>{customer.pcode} {customer.city}</div>
                  </div>

                  {/*<div className="pa2">*/}
                  {/*  <div className={"black-70 ttu f6"}>{translate( "Ansprechpartner" )}</div>*/}
                  {/*  <div className={"b black-90 f5"}>{customer.email}</div>*/}
                  {/*</div>*/}

                  {/*<pre>{JSON.stringify( customer, null, 2 )}</pre>*/}
                </div>

              </div>
            </div>
          </Container>

        </div>

        <div className="pv5 bg-white">
          <Container>
            <section>
              <h2 className="b">{translate( "Konten" )}</h2>
              <Table>
                <Table.Header>
                  <Table.Row>
                    {/*<Table.HeaderCell>#</Table.HeaderCell>*/}
                    <Table.HeaderCell>{translate( "Name" )}</Table.HeaderCell>
                    <Table.HeaderCell>{translate( "E-Mail" )}</Table.HeaderCell>
                    {/*<Table.HeaderCell>Kontakt</Table.HeaderCell>*/}
                    <Table.HeaderCell>{translate( "Rechte" )}</Table.HeaderCell>
                    <Table.HeaderCell>&nbsp;</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>

                  {users.length === 0 && <Table.Row>
                    <Table.Cell colSpan={5}>{translate( "Legen Sie den ersten Benutzer an" )}</Table.Cell>
                  </Table.Row>}

                  {users && users.map( user => {
                    return <Table.Row key={user.id}>
                      {/*<Table.Cell>{user.id}</Table.Cell>*/}
                      <Table.Cell>{user.name}</Table.Cell>
                      <Table.Cell>{user.email}</Table.Cell>
                      {/*<Table.Cell>{user.customer_id}</Table.Cell>*/}
                      <Table.Cell>{user.roles.map( translate ).join( ", " )}</Table.Cell>
                      <Table.Cell>
                        <div className="tr"><Button
                          onClick={() => {
                            setShowEditAccountModal( user )
                          }}
                          basic>{translate( "bearbeiten" )}</Button></div>
                      </Table.Cell>
                    </Table.Row>
                  } )}

                  <Table.Row>
                    <Table.Cell colSpan={6}>
                      <div className="tr">
                        <Button onClick={() => {
                          setShowNewAccountModal( true )
                        }} primary>{translate( "Konto hinzufügen" )}</Button>
                      </div>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </section>
          </Container>
        </div>

        {/*<pre>{JSON.stringify( { users }, null, 2 )}</pre>*/}
        {/*<pre>{JSON.stringify( { customer, users, costCentres, params }, null, 2 )}</pre>*/}

      </div>
    </div>}
  </div>
}


async function postNewLogin( { userId, login, email, pwd, pwd2 } ) {
  console.log( { userId, login, email, pwd, pwd2 } )
  try {
    await shop.fetch( `/shop/rest/security/user/${userId}/logins`, {
      method: "POST",
      body: JSON.stringify( {
                              active: true,
                              id: 0,
                              login: login || email,
                              password: pwd,
                              repeat: pwd2,
                              userid: userId
                            } )
    } )
  }
  catch (err) {
    console.log( err )
    shop.toast( err )
  }
}

async function postNewAccount( { email, name, pwd, pwd2, roles, customerId }, setBusy, onClose ) {
  console.log( { email, name, pwd, pwd2, roles } )
  if ( !pwd || (pwd !== pwd2) ) {
    shop.toast( "Passwörter stimmen nicht überein", "warning" )
    return
  }

  if ( !name || name.length < 2 ) {
    shop.toast( "Name muss ausgefüllt sein", "warning" )
    return
  }

  setBusy( true )

  let res = await shop.fetch( "/shop/rest/users/data", {
    method: "POST",
    body: JSON.stringify( {
                            "customer_id": customerId,
                            "contact_id": "",
                            "handuser_id": "",
                            "temp": false,
                            "name": name,
                            "email": email,
                            "roles": roles,
                            "forceCostcentre": true
                          } )
  } )
  try {
    await postNewLogin( { userId: res.id, email, pwd, pwd2 } )
  }
  catch (err) {
    console.error( err )
    // LOGIN ALREADY EXISTS
  }
  setBusy( false )
  shop.toast( "Konto erstellt", "success" )
  onClose( false )
  console.log( { res } )
}


async function postAccount( { id, email, name, pwd, pwd2, roles, customer_id,forceCostcentre }, setBusy, onClose, onCreate ) {
  if ( !name || name.length < 2 ) {
    shop.toast( "Name muss ausgefüllt sein", "warning" )
    return
  }

  setBusy( true )
  let res
  try {
    res = await shop.fetch( "/shop/rest/users/data", {
      method: "POST",
      body: JSON.stringify( {
                              forceCostcentre: true,
                              id: id,
                              customer_id,
                              "contact_id": "",
                              "handuser_id": "",
                              "temp": false,
                              "name": name,
                              "email": email,
                              "roles": roles
                            } )
    } )
    try {
      if ( pwd && pwd2 ) {
        await postNewLogin( { userId: res.id, email, pwd, pwd2 } );
      }
    }
    catch (err) {
      console.error( err )
      // LOGIN ALREADY EXISTS
    }
  }
  catch (err) {
    shop.toast( err, "error" )
    res = false
  }
  if ( res ) {
    shop.toast( "Konto gespeichert", "success" )
    onCreate( res )
    onClose( false )
  }

  setBusy( false )

}

export function CreateCustomerModal( { user, customer, customerId, open, onClose } ) {
  const [busy, setBusy] = useState( false )
  const [form, _setForm] = useState( {} )
  const setForm = ( data ) => {
    _setForm( Object.assign( form, data ) )
  }

  return <Modal as={Form} onSubmit={() => {
    const { email, name, pwd, pwd2, roles } = form
    postNewAccount( { email, name, pwd, pwd2, roles, customerId }, setBusy, onClose )
  }}
                size={"small"} open={open}>
    <Modal.Header>
      <div className="ph4-ns ph3-m ph0">
        <div className="b f2-ns f3 pt2 pb2">{customer.title || translate( "Neues Konto" )}</div>
        <div className="f5 black-60">{translate( "Konto erstellen" )}</div>
      </div>
    </Modal.Header>
    <Modal.Content>
      <div className="ph4-ns ph3-m ph0">

        <Form.Field>
          <label>{translate( "Name" )}</label>
          <Input name={"name"} onChange={e => {
            setForm( { [ e.currentTarget.name ]: e.currentTarget.value } )
          }} required/>
        </Form.Field>

        <Form.Field>
          <label>{translate( "Benutzername" )} (E-Mail)</label>
          <Input name={"email"} onChange={e => {
            setForm( { [ e.currentTarget.name ]: e.currentTarget.value } )
          }} type={"email"} required/>
        </Form.Field>

        <Form.Field>
          <label>{translate( "Passwort" )}</label>
          <Input name={"pwd"} onChange={e => {
            setForm( { [ e.currentTarget.name ]: e.currentTarget.value } )
          }} required/>
        </Form.Field>

        <Form.Field>
          <label>{translate( "Passwort (Wiederholung)" )}</label>
          <Input name={"pwd2"} onChange={e => {
            setForm( { [ e.currentTarget.name ]: e.currentTarget.value } )
          }} required/>
        </Form.Field>

        <Form.Field>
          <label htmlFor="">{translate( "Rechte" )}</label>
          <Dropdown
            placeholder="Rechte"
            fluid
            multiple
            search
            selection
            defaultValue={["besteller"]}
            onChange={( event, data ) => {
              console.log( data )
              setForm( { roles: data.value } )
            }}
            options={shop.session.shopuser && shop.session.shopuser.roles.map( key => ({
              key, value: key, text: translate( key )
            }) )}
          />
        </Form.Field>
      </div>

    </Modal.Content>
    <Modal.Actions>
      <div className="ph4-ns ph3-m ph0 pb3 pt3">
        <div>
          <Button type={"button"} onClick={() => {
            onClose( false )
          }}>{translate( "Zurück" )}</Button>
          <Button loading={busy} type="submit" primary>{translate( "Speichern" )}</Button>
        </div>
      </div>
    </Modal.Actions>
  </Modal>
}

export function EditCustomerModal( { user, customer, open, onClose } ) {
  const [login, setLogin] = useState( false )
  const customer_id = customer.map_id
  const [logins, setLogins] = useState( [] )
  const [showChangePass, setShowChangePass] = useState( false )
  const userId = user && user.id

  const [busy, setBusy] = useState( false )
  const [form, _setForm] = useState( {} )
  const setForm = ( data ) => {
    _setForm( Object.assign( form, data ) )
  }

  const [loginForm, _setLoginForm] = useState( {} )
  const setLoginForm = ( data ) => {
    _setLoginForm( Object.assign( loginForm, data ) )
  }
  const updateUser = () => {
    const { email, name, roles } = form
    postAccount( {
                   ...user,
                   email: email || user.email,
                   name: name || user.name,
                   roles,
                   customer_id
                 },
                 setBusy, onClose
    )
  }
  useEffect( loadState( setLogins, `/shop/rest/security/user/${userId}/logins`, !!userId ), [userId] )
  const isEditMode = !!login.active
  return <Modal size={login ? "tiny" : null} open={open}>
    {/*EDIT LOGIN*/}
    {login && <React.Fragment>
      <Modal.Header>
        <div className="absolute top-2 right-2">
          <Button basic circular onClick={() => {
            setLogin( false )
          }} icon={"close"}/>
        </div>
        <div className="ph4-ns ph3-m ph0">
          <div className="b f2-ns f3 pt2 pb2">{customer.title || login.login || translate( "neuer Login" )}</div>
          <div className="f5 black-60 animate fadeIn">{isEditMode ? translate( "Login bearbeiten" ) : translate( "neuer Login" )}</div>
        </div>
      </Modal.Header>
      <Modal.Content>

        {/*<pre>{JSON.stringify( login, null, 2 )}</pre>*/}
        <div className="ph4-ns ph3">
          <Form onSubmit={async () => {
            await postNewLogin( {
                                  ...login,
                                  userId,
                                  email: loginForm.email || login.email,
                                  login: loginForm.login || login.login,
                                  pwd: loginForm.pwd,
                                  pwd2: loginForm.pwd2
                                } )

            shop.toast( "Gespeichert", "success" )
            setLogin( false )
          }}>

            <Form.Field>
              <label>{translate( "E-Mail" )}</label>
              <Input
                disabled={isEditMode}
                defaultValue={login.login}
                value={form.login}
                name={"login"}
                onChange={e => {
                  // Can only edit for existing logins pwd
                  if ( isEditMode ) return
                  console.log( { form }, e.currentTarget.name, e.currentTarget.value )
                  setLoginForm( { [ e.currentTarget.name ]: e.currentTarget.value } )
                }} required/>
            </Form.Field>

            <Form.Field>
              <label>{translate( "Passwort" )}</label>
              <Input
                value={form.pwd}
                name={"pwd"} onChange={e => {
                setLoginForm( { [ e.currentTarget.name ]: e.currentTarget.value } )
              }} required/>
            </Form.Field>

            <Form.Field>
              <label>{translate( "Passwort (Wiederholung)" )}</label>
              <Input
                value={form.pwd2}
                name={"pwd2"} onChange={e => {
                setLoginForm( { [ e.currentTarget.name ]: e.currentTarget.value } )
              }} required/>
            </Form.Field>

          </Form>
        </div>
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={() => {
          setLogin( false )
        }}>{translate( "Zurück" )}</Button>
        <Button primary onClick={async () => {
          await postNewLogin( {
                                ...login,
                                userId,
                                email: loginForm.email || login.email,
                                login: loginForm.login || login.login,
                                pwd: loginForm.pwd,
                                pwd2: loginForm.pwd2
                              } )
          shop.toast( "Gespeichert", "success" )
          setLogin( false )
        }
        }>{translate( "Speichern" )}</Button>
      </Modal.Actions>

    </React.Fragment>}


    {!login && <React.Fragment>
      <Modal.Header>
        <div className="absolute top-2 right-2">
          <Button basic circular onClick={onClose} icon={"close"}/>
        </div>
        <div className="ph4-ns ph3-m ph0">
          <div className="b f2-ns f3 pt2 pb2">{user.name}</div>
          <div className="f5 black-60">#{user.id}</div>
        </div>
      </Modal.Header>

      <Modal.Content>
        {/*<div className="f7">*/}
        {/*  <pre>{JSON.stringify( user, null, 2 )}</pre>*/}
        {/*  <pre>{JSON.stringify( customer, null, 2 )}</pre>*/}
        {/*  <pre>{JSON.stringify( logins, null, 2 )}</pre>*/}
        {/*  <pre>{JSON.stringify( form, null, 2 )}</pre>*/}
        {/*</div>*/}

        <div className="ph4-ns ph3-m ph0">
          <div className="">
            <h3>{translate( "Konto" )}</h3>
            <Form onSubmit={updateUser}>
              <Form.Field>
                <label>{translate( "Name" )}</label>
                <Input
                  defaultValue={user.name}
                  value={form.name}
                  name={"name"} onChange={e => {
                  setForm( { [ e.currentTarget.name ]: e.currentTarget.value } )
                }} required/>
              </Form.Field>

              <Form.Field>
                <label>{translate( "E-Mail" )}</label>
                <Input
                  defaultValue={user.email}
                  value={form.email}
                  name={"email"} onChange={e => {
                  setForm( { [ e.currentTarget.name ]: e.currentTarget.value } )
                }} required/>
              </Form.Field>

              <Form.Field>
                <label htmlFor="">{translate( "Rechte" )}</label>
                <Dropdown
                  placeholder="Rechte"
                  fluid
                  multiple
                  search
                  selection
                  defaultValue={user.roles}
                  onChange={( event, data ) => {
                    console.log( data )
                    setForm( { roles: data.value } )
                  }}
                  options={shop.session.shopuser.roles.map( key => ({
                    key, value: key, text: translate( key )
                  }) )}
                />
              </Form.Field>
            </Form>
          </div>

          {logins.length > 0 && <div className="pt4">
            <h3>Logins</h3>
            <CustomerLoginForm onSelect={login => {
              setLogin( login )
            }} logins={logins}/>
          </div>}

        </div>

      </Modal.Content>
      <Modal.Actions>
        <div className="ph4-ns ph3-m ph0 pb3 pt3">
          <div className="flex flex-row items-center">
            <Button basic onClick={() => {
              setLogin( {} )
            }}>{translate( "Neuer Login" )}</Button>

            <div className="ml-auto">
              <Button type={"button"} onClick={() => {
                onClose( false )
              }}>{translate( "Zurück" )}</Button>
              <Button type="submit"
                      onClick={updateUser}
                      primary>{translate( "Speichern" )}</Button>
            </div>

          </div>
        </div>
      </Modal.Actions>
    </React.Fragment>}

  </Modal>
}


export function CustomerLoginForm( { onSelect, logins = [] } ) {


  return <div className={"CustomerLoginForm"}>
    {logins.map( login => {
      const mLastLogin = moment( login.lastlogin )
      const isNever = mLastLogin.isBefore( "1980" )
      return <div key={login.login} className="flex flex-row items-center pt2 pb2 mb2 bt b--light-gray">
        <div>
          <div className="f6 black-70 ttu">{translate( "Benutzername" )} (E-Mail)</div>
          <div className={"f5 b"}>{login.login}</div>
        </div>

        <div className="ml-auto pr4-ns pr3">
          <div className="f6 black-70 ttu">{translate( "Letzte Anmeldung" )}</div>
          <div className="tr f5 b">{isNever ? "-" : moment( login.lastlogin ).fromNow()}</div>
        </div>

        {/*<div className="pr4-ns pr3">*/}
        {/*  <div className="f6 black-70 ttu">Status</div>*/}
        {/*  <div>{login.active ? <Label color="black" size={"tiny"}>ACTIVE</Label> : <Label size={"tiny"}>INACTIVE</Label>}</div>*/}
        {/*</div>*/}

        <div>
          <Button onClick={() => {
            onSelect( login )
          }} basic size="tiny">{translate( "bearbeiten" )}</Button>
        </div>
      </div>
    } )}
  </div>
}



// WEBPACK FOOTER //
// ./src/theme/oehme/components/Budget/CustomerDetailPage.js